<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.66113 18.3386L7.25499 13.7447M18.2175 2.78223C21.9275 6.49221 21.9275 12.5073 18.2175 16.2173C14.5075 19.9272 8.49243 19.9272 4.78245 16.2173M17 21.9997H6.99997M12 21.9997V18.9997M17.5 9.49974C17.5 12.8134 14.8137 15.4997 11.5 15.4997C8.18626 15.4997 5.49997 12.8134 5.49997 9.49974C5.49997 6.18603 8.18626 3.49974 11.5 3.49974C14.8137 3.49974 17.5 6.18603 17.5 9.49974Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
